export default __webpack_public_path__ + "static/media/internationalBG.d8e5c7b3.jpg";